import cuiTitle from './title.vue'


export default {
    install: function (Vue) {
        Vue.component('cui-title', cuiTitle)
    }
}